// Eski kadro adresleri birleşik Kadrolar sayfasına yönlenir; sorgu korunur.
//   /editor/kadro-onaylari         → /editor/kadrolar?tur=sezon
//   /editor/kadro-listeleri?liste=5 → /editor/kadrolar?tur=liste&liste=5
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROSTERS_PATH } from "../adminNav";

export const legacyRosterTarget = (kind, search = "") => {
  const params = new URLSearchParams(search);
  if (!params.has("tur")) params.set("tur", kind);
  return `${ROSTERS_PATH}?${params.toString()}`;
};

export default function LegacyRosterRedirect({ kind }) {
  const location = useLocation();
  return <Navigate to={legacyRosterTarget(kind, location.search)} replace />;
}
